import * as userActions from './actions';

import { catchError, filter, map, mapTo, switchMap, withLatestFrom } from 'rxjs/operators';
import { concat, of } from 'rxjs';

import { Epic } from 'redux-observable';
import { RootAction } from 'store/actions';
import { RootDependencies } from 'store/dependencies';
import { RootState } from 'store/reducer';
import { externalLogin } from './actions';
import { getBuilding } from 'store/building/actions';
import { getBuildingTheme } from 'store/theme/actions';
import { isActionOf } from 'typesafe-actions';
import qs from 'qs';
import { replace } from 'connected-react-router';

export const externalLoginEpic: Epic<RootAction, RootAction, RootState, RootDependencies> = (
  action$,
  state$,
  { apiClient },
) =>
  action$.pipe(
    filter(isActionOf(userActions.externalLogin.request)),
    withLatestFrom(state$),
    switchMap(([, state]) => {
      const { authToken, apiUrl } = state.config;

      return apiClient(state, apiUrl, authToken)
        .getCurrentUser()
        .pipe(
          map(xhrPayload => userActions.externalLogin.success({ user: xhrPayload.response, apiUrl, token: authToken })),
          catchError((error: Error) => {
            return of(userActions.externalLogin.failure({ error }));
          }),
        );
    }),
  );

export const externalLoginRedirect: Epic<RootAction, RootAction, RootState> = (action$, state$) =>
  action$.pipe(
    filter(isActionOf(userActions.externalLogin.success)),
    withLatestFrom(state$),
    map(() => {
      const search: string = window.location?.search ?? '';
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { authToken, apiUrl, ...restSearch } = qs.parse(search.replace(/^\?/, ''));
      const newSearchString = qs.stringify(restSearch);
      const path = window.location?.pathname ?? '/';

      return replace(newSearchString ? `${path}?${newSearchString}` : path);
    }),
  );

export const externalLoginFailureRedirect: Epic<RootAction, RootAction, RootState> = action$ =>
  action$.pipe(filter(isActionOf(userActions.externalLogin.failure)), mapTo(replace('/')));

export const getCurrentUser: Epic<RootAction, RootAction, RootState, RootDependencies> = (
  action$,
  state$,
  { apiClient },
) =>
  action$.pipe(
    filter(isActionOf(userActions.getCurrentUser.request)),
    withLatestFrom(state$),
    switchMap(([, state]) =>
      apiClient(state)
        .getCurrentUser()
        .pipe(
          map(xhrPayload => {
            return userActions.getCurrentUser.success({ user: xhrPayload.response });
          }),
          catchError((error: Error) => {
            return of(userActions.getCurrentUser.failure({ error }));
          }),
        ),
    ),
  );

export const refetchAfterRefreshToken: Epic<RootAction, RootAction, RootState, RootDependencies> = action$ =>
  action$.pipe(
    filter(isActionOf(userActions.refreshToken)),
    switchMap(() => concat(of(getBuilding.request(), getBuildingTheme.request(), externalLogin.request()))),
  );
